module.exports = __webpack_public_path__ + "static/media/van-avatar.8aaa9356.svg";